// + de paramètres possible sur https://swiperjs.com/demos et sur https://swiperjs.com/swiper-api
document.addEventListener("DOMContentLoaded", function() {
    
    const swiper3 = new Swiper('.widgetActualite-swiper', {
        modules: [Pagination, Autoplay],
        
        // Optional parameters
        loop: true,
        autoplay: {
           delay: 2500,
        },
        pagination: {
            el: ".widgetActualite-pagination",
            bulletClass: 'swiper-pagination-bullet widgetActualite-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active widgetActualite-bullet--active',
            clickable: true
        },
        spaceBetween: 20,
        breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 50,
            },
            1920: {
              slidesPerView: 3,
              spaceBetween: 50,
            }
        }
    });

    const swiper5 = new Swiper('#galerie-slider', {
        modules: [Navigation, Pagination],
        
        // Optional parameters
        spaceBetween: 20,
        loop: true,
        speed: 1000,
        slidesPerView: 1,
        pagination: {
            el: '.widgetGalerie-pagination',
            clickable: true,
        },
        
        breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 50,
            },
            1920: {
              slidesPerView: 3,
              spaceBetween: 50,
            }
        },
    });

    const swiper7 = new Swiper('.widgetAuto-swiper', {
        modules: [Navigation, Pagination],

        // Optional parameters
        spaceBetween: 30,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 50,
            },
            1920: {
              slidesPerView: 3,
              spaceBetween: 100,
            }
        },
    });

    const swiper10 = new Swiper('.widgetGoogleReviews-swipe', {
        modules: [Navigation, Pagination],
        
        // Optional parameters
        spaceBetween: 15,
        loop: true,
        grabCursor: true,
        pagination: {
            el: '.widgetGoogleReviews-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: ".widgetGoogleReviews-button-next",
            prevEl: ".widgetGoogleReviews-button-prev",
        },
        breakpoints: {
            468: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 3,
            },
            1440: {
              slidesPerView: 3,
            },
            1680: {
              slidesPerView: 4,
            }
        },
    });
});